import React from "react";
import {Link} from "react-router-dom";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import {useTranslation} from "react-i18next";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Badge from "@material-ui/core/Badge";
import WarningIcon from "@material-ui/icons/Warning";
import ProfileIcon from "../ProfileIcon";
import {useCommun} from "../../../Providers/commun";
import Divider from "@material-ui/core/Divider";
import Bell from "../../../Assets/CommunIcons/Bell.svg";
import WlmLogo2 from "../../../Assets/icon/wlm2.svg";
import isMobile from "../../../Services/isMobile";
import Menu_Active from "../../../Assets/CommunIcons/icon_menu_buger_Open.svg";
import Menu_Inactive from "../../../Assets/CommunIcons/icon_menu_buger_Close.svg";

import {
    Container,
    Logo,
    Notify,
    Right,
    Left,
    UseStyle,
    HR,
    MenuButton,
} from "./styles";
import useApp from "../../../Providers/app";

const MainHeader = () => {

    const app = useApp();
    const {informatios, setIsAsideOpen, isAsideOpen, screenWidth} = useCommun();
    const {t} = useTranslation();
    const classe = UseStyle();
    var badg = 0;
    if (localStorage.getItem("color") === "red") {
        badg = 1;
    }

    const [anchorEl2, setAnchorEl2] = React.useState(null);
    const handleClick2 = (event) => {
        setAnchorEl2(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl2(null);
    };
    const open2 = Boolean(anchorEl2);

    return (
        <Container>
            <Left>
                {isMobile() && screenWidth <= 600 &&
                    <MenuButton onClick={() => setIsAsideOpen(!isAsideOpen)}>
                        {isAsideOpen === true ?
                            <img src={Menu_Active} /* onClick={open} */ style={{cursor: "pointer", margin: "auto"}}
                                 alt=""/>
                            : <img src={Menu_Inactive} /* onClick={open} */ style={{cursor: "pointer", margin: "auto"}}
                                   alt=""/>
                        }
                    </MenuButton>
                }
                <Link to="/campaigns/dashboard"><Logo src={isMobile() ? WlmLogo2 : app.logo} alt={app.name}/></Link>
            </Left>
            <Right>
                <Notify>
                    <Badge onClick={handleClick2} badgeContent={badg} variant="dot" color="secondary">
                        <img src={Bell} alt=""/>
                    </Badge>
                </Notify>
                <HR/>
                <ProfileIcon name={app.name} fone={informatios.phoneNumber} info="commun"/>
            </Right>
            <Popover
                open={open2}
                anchorEl={anchorEl2}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                <Typography className={classe.typography}>
                    <div className={classe.roots}>
                        <List component="nav" aria-label="main mailbox folders">
                            {localStorage.getItem("color") === "red" &&
                                <ListItem>
                                    <ListItemIcon style={{width: "15%"}}>
                                        <WarningIcon style={{color: "red"}}/>
                                    </ListItemIcon>
                                    <ListItemText primary={t("words.disconnected_phone")}/>
                                </ListItem>
                            }
                            <ListItem>
                                <ListItemIcon style={{width: "15%"}}>
                                </ListItemIcon>
                                <ListItemText primary=""/>
                            </ListItem>
                        </List>
                        <Divider/>
                    </div>
                </Typography>
            </Popover>
        </Container>
    );
};

export default MainHeader;